import { CaseReducer, PayloadAction } from '@reduxjs/toolkit'
import { BomItemType } from 'model/Project/BoMItemRow'
import { BomItemPointer } from 'model/Project/BomItemPointer'
import { BoMItemActivityDto } from 'services/APIs/InternalAPI/internal-api.contracts'
import { draftMerge } from 'utils/draftMerge'
import { ProjectState } from '../../../../store/Project/ProjectTypes'
import { bomItemSelector } from '../selectors/bomItemSelector'

export const bomItemWorkingStepsReplacer: CaseReducer<
  ProjectState,
  PayloadAction<{
    bomItemPointer: BomItemPointer
    activityId: string
    workingStep: Partial<BoMItemActivityDto>
  }>
> = (state, action) => {
  if (action.payload.bomItemPointer.id === state.activeProject?.id) {
    state.activeProject.activities.forEach((ws, idx) => {
      if (ws.id === action.payload.activityId) {
        state.activeProject.activities[idx] = draftMerge(
          ws,
          action.payload.workingStep,
        )
      }
    })

    return state
  }

  const bomItem = bomItemSelector(
    { project: state },
    action.payload.bomItemPointer,
  )

  switch (bomItem?.type) {
    case BomItemType.assemblyType: {
      bomItem.assemblyActivities.forEach((ws, idx) => {
        if (ws.id === action.payload.activityId) {
          bomItem.assemblyActivities[idx] = draftMerge(
            ws,
            action.payload.workingStep,
          )
        }
      })
      break
    }
    case BomItemType.assemblyInstance:
      bomItem.assemblyActivities.forEach((ws, idx) => {
        if (ws.id === action.payload.activityId) {
          bomItem.assemblyActivities[idx] = draftMerge(
            ws,
            action.payload.workingStep,
          )
        }
      })
      break
    case BomItemType.partType:
    case BomItemType.partInstance: {
      bomItem.activities.forEach((ws, idx) => {
        if (ws.id === action.payload.activityId) {
          bomItem.activities[idx] = draftMerge(ws, action.payload.workingStep)
        }
      })
    }
  }

  return state
}
